module.exports = __webpack_public_path__ + "static/img/7.c9beed7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/eng/7.png
// module id = t95k
// module chunks = 0